import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import FlatButton from 'material-ui/FlatButton'

import DateArrow from './DateArrow'

export default class DateSelector extends React.Component {

  static propTypes = {
    startDateStr: PropTypes.string.isRequired,
    endDateStr: PropTypes.string.isRequired,
    singleDay: PropTypes.bool.isRequired,
    onTodayClicked: PropTypes.func.isRequired,
    onDateChanged:  PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    const startDate = moment(props.startDateStr)
    const endDate = moment(props.endDateStr)
    this.state = {
      startDate: startDate,
      endDate: endDate,
      rangeDays: endDate.diff(startDate, 'days') + 1,
      singleDay: props.singleDay
    }
  }

  componentWillReceiveProps(nextProps) {
    const startDate = moment(nextProps.startDateStr)
    const endDate = moment(nextProps.endDateStr)
    this.setState({
      startDate: startDate,
      endDate: endDate,
      rangeDays: endDate.diff(startDate, 'days') + 1,
      singleDay: nextProps.singleDay
    })
  }

  onStartDateChange(date) {
    const startDate = this.state.startDate
    const endDate = this.state.endDate
    const diffDays = endDate.diff(startDate, 'days')

    const newStartDate = moment(date)
    const newEndDate = moment(newStartDate).add(diffDays, 'days')

    this.setState({
      startDate: newStartDate,
      endDate: newEndDate
    })
    const dateFormat = 'YYYY-MM-DD'
    this.props.onDateChanged(
      newStartDate.format(dateFormat),
      newEndDate.format(dateFormat))
  }

  onLeftPressed() {
    this.onStartDateChange(moment(this.state.startDate).subtract(this.state.rangeDays, 'days'))
  }

  onRightPressed() {
    this.onStartDateChange(moment(this.state.endDate).add(1, 'days'))
  }

  render() {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: '#fafafa'}}>
        <FlatButton
          style={{ border: '1px solid #e2e2e2', marginRight: 4 }}
          labelStyle={{ color: '#4d6f7f', fontWeight: 400 }}
          label='Today'
          onTouchTap={this.props.onTodayClicked} />
        <div
          style={{ border: '1px solid #e2e2e2', marginRight: 4 }}>
          <DateArrow
            direction={DateArrow.Direction.LEFT}
            onPress={this.onLeftPressed.bind(this)}/>
        </div>
        <div
          style={{ border: '1px solid #e2e2e2' }}>
          <DateArrow
            direction={DateArrow.Direction.RIGHT}
            onPress={this.onRightPressed.bind(this)} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/date/DateSelector.js